import { SavedConfiguration } from './../../shared/configuration.model';

import {merge as observableMerge,  BehaviorSubject ,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { AuthenticationService } from '../../shared/authentication.service';
import { Component, ElementRef, ViewChild, OnInit, forwardRef, ChangeDetectorRef, Inject } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTable, MatDialog, MAT_DIALOG_DATA } from '@angular/material';






import { ActivatedRoute, Router, Params } from '@angular/router';

import { Configuration } from '../../shared/configuration.model';
import { ConfigurationService } from '../../shared/configuration.service';
import { MyDialogComponent } from '../my-dialog/my-dialog.component';
import { isNull, isNullOrUndefined } from 'util';

@Component({
  selector: "app-package",
  templateUrl: "./view-package.component.html",
  styleUrls: ["./view-package.component.scss"]
})

export class ViewPackageComponent implements OnInit {
  isDataAvailable = false;
  loading = false;
  screen = false;
  displayedColumns = ['QualityAttribute', 'QualityAttributeValue', 'QualityAttributeCount', 'SourceType', 'EditConfiguration'];
  dataChange: BehaviorSubject<SavedConfiguration[]> = new BehaviorSubject<SavedConfiguration[]>([]);
  selection = new SelectionModel<string>(true, []);
  get data(): SavedConfiguration[] { return this.dataChange.value; }
  dataSource: ConfigurationDataSource | null;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  private packageId: number;
  public packageName: string;
  public config: SavedConfiguration;
  public addConfig: Configuration;

  constructor(private configurationService: ConfigurationService,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    public auth: AuthenticationService,
    public dialog: MatDialog) {
  }
  populateConfigurationQueue() {
    this.route.params.subscribe(params => {
      this.packageId = params['id'];
    });

    this.configurationService.getPackageName(this.packageId, this.auth.currentState).subscribe(res => {
      this.packageName = res["PackageName"];
    });
    this.configurationService.getConfigs(this.packageId, this.auth.currentState).subscribe(rcgitems => {
      this.dataChange.next(rcgitems);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
    });
  }

  ngOnInit() {

    this.populateConfigurationQueue();
  }

  initSource() {
    this.dataSource = new ConfigurationDataSource(this, this.sort);
    this.cdRef.detectChanges();
  }

  return() {
    this.router.navigate(["/viewpackage"]);
  }

  openDialogUpdate(config: SavedConfiguration) {
    let dialogRef = this.dialog.open(MyDialogComponent, {
      width: '600px',
      data: config
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {
        return;
      }
      else{
        this.updateRow(result);
      }
    });
  }

  openDialogAdd() {
    let dialogRef = this.dialog.open(MyDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {
        return;
      }
      else{
       
        this.addRow(result);
      }
    });
  }

  updateRow(result){
    this.config = new SavedConfiguration(result.configid, this.packageId, result. source,
      result.sourcevalue, result.sourcevaluecount, result.configurationtype);
      this.screen = true;
      this.configurationService.updateConfiguration(this.config, this.auth.currentState).subscribe(res => {
        this.configurationService.getConfigs(this.packageId, this.auth.currentState).subscribe(rcgitems => {
        this.dataChange.next(rcgitems);
        this.isDataAvailable = true;
        this.screen = false;
        this.cdRef.detectChanges();
        this.initSource();
      });
  });
  }
  addRow(result){
    this.addConfig = new Configuration(this.packageId, result. source,
          result.sourcevalue, result.sourcevaluecount, result.configurationtype);
          this.screen = true;
    this.configurationService.addConfig(this.addConfig, this.auth.currentState).subscribe(rcgitems => {
      this.dataChange.next(rcgitems);
      this.isDataAvailable = true;
      this.screen = false;
      this.cdRef.detectChanges();
      this.initSource();
    });
  }
}



export class ConfigurationDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<SavedConfiguration[]> = new BehaviorSubject<SavedConfiguration[]>([]);
  get data(): SavedConfiguration[] { return this.dataChange.value; }

  filteredData: SavedConfiguration[] = [];
  renderedData: SavedConfiguration[] = [];

  constructor(private rcgcomponent: ViewPackageComponent,
    private _sort: MatSort) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<SavedConfiguration[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      return this.sortData();
    }));
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(): SavedConfiguration[] {
    const data = this.rcgcomponent.data.slice();
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'QualityAttribute': [propertyA, propertyB] = [a.QualityAttribute, b.QualityAttribute]; break;
        case 'QualityAttributeValue': [propertyA, propertyB] = [a.QualityAttributeValue, b.QualityAttributeValue]; break;
        case 'QualityAttributeCount': [propertyA, propertyB] = [a.QualityAttributeCount, b.QualityAttributeCount]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}